import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import { localizationEn } from './assets/locales/en/translation'
import { localizationRu } from './assets/locales/ru/translation'

const resources = {
  en: {
    translation: localizationEn,
  },
  ru: {
    translation: localizationRu,
  },
}
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    lng: 'en',

    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
